import { forwardRef, ForwardedRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import ComposedViewAgGrid, { IComposedViewAgGridProps } from 'ComposedView/ComposedViewAgGrid';
import Grid, { IGridProps } from '../Grid/Grid';
import { ComposedGridProvider } from './ComposedGridContext';

export interface IComposedGridProps<D = any>
  extends IGridProps<D>,
    Omit<IComposedViewAgGridProps, 'children' | 'hidePagination'> {}

function ComposedGrid<D>(props: IComposedGridProps<D>, ref: ForwardedRef<AgGridReact<D>>) {
  const {
    bulkActionsOptions,
    columnsOptions,
    controlBarOptions,
    filterChipsOptions,
    filterOptions,
    footerSticky,
    hideColumns,
    hideExport,
    hideFilterChips,
    hideFilters,
    hidePrint,
    hideRefresh,
    hideSavedViews,
    hideSearch,
    pagination,
    paginationOptions,
    savedViewsOptions,
  } = props;
  return (
    <ComposedGridProvider>
      <ComposedViewAgGrid
        bulkActionsOptions={bulkActionsOptions}
        columnsOptions={columnsOptions}
        controlBarOptions={controlBarOptions}
        filterChipsOptions={filterChipsOptions}
        filterOptions={filterOptions}
        footerSticky={footerSticky}
        hideColumns={hideColumns}
        hideExport={hideExport}
        hideFilterChips={hideFilterChips}
        hideFilters={hideFilters}
        hidePagination={!pagination}
        hidePrint={hidePrint}
        hideRefresh={hideRefresh}
        hideSavedViews={hideSavedViews}
        hideSearch={hideSearch}
        paginationOptions={paginationOptions}
        savedViewsOptions={savedViewsOptions}
      >
        <Grid<D>
          ref={ref}
          pagination={pagination}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      </ComposedViewAgGrid>
    </ComposedGridProvider>
  );
}

export default forwardRef(ComposedGrid);
